'use client';

import Image from 'next/image';
import { useState } from 'react';

import { cn } from '@app/libs/utils';

import RotatingText from '../ui/RotatingText';

interface MainHeroProps {
  className?: string;
}

export const MainHero = ({ className }: MainHeroProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <section className={cn('relative overflow-hidden', 'bg-dot', className)}>
      {/* Main Container */}
      <div className="2xl:w-[90rem] w-full mx-auto relative z-30 flex items-center items-center justify-center px-5 py-10 lg:py-30">
        <div className="w-full flex flex-col lg:flex-row gap-10 items-center justify-between">
          {/* Left Content */}
          <div className="flex-1 flex flex-col gap-10 w-full lg:w-auto min-w-1/2">
            {/* Text Content */}
            <div className="flex flex-col gap-5">
              <h2 className="text-base text-gray-900">
                Với hơn <b>1000+</b> tin đăng bán mỗi ngày
              </h2>
              <h1 className="text-xl lg:text-3xl font-bold text-gray-900 uppercase gap-2">
                <span className="flex items-center gap-2 text-nowrap">
                  Giúp bạn dễ dàng
                  <RotatingText
                    texts={['Tìm kiếm', 'Giao dịch']}
                    wrapperClassName="bg-blue-500 px-2 lg:px-5 py-3 rounded-sm text-white"
                    elementLevelClassName="text-nowrap"
                  />
                </span>
                <span>bất động sản</span>
              </h1>
            </div>

            {/* Button */}
            <div className="flex flex-col gap-15">
              <button className="inline-flex items-center justify-center gap-2.5 px-6 py-3 bg-blue-800 text-white text-lg font-bold leading-[1.5] rounded-[10px] hover:bg-[#1e3a6b] transition-colors duration-200 w-fit">
                Tìm kiếm ngay
              </button>
            </div>
          </div>

          {/* Right Image Section */}
          <div className="relative w-full lg:w-auto">
            {/* Vector Decoration */}
            <Image
              src="/images/hero/hero-vector.svg"
              alt="Decoration"
              width={296}
              height={242}
              className="absolute top-0 left-0 z-1 max-w-1/3 lg:max-w-full min-w-[100px]"
            />

            {/* Overlay Image */}
            <div className="rounded-[10px] overflow-hidden relative z-10 max-w-[500px] lg:max-w-full min-w-[300px]">
              <Image
                src="/images/hero/hero-image-2-7e921d.png"
                alt="Real Estate Property Overlay"
                className="object-fill w-full lg:w-[640px] h-full"
                height={687}
                width={640}
              />
            </div>

            {/* Stats Card */}
            <div
              className={cn(
                'absolute bottom-2 right-0 z-20 bg-gradient-to-b from-[#5369AC] to-[#324067]',
                'rounded-l-[10px] rounded-r-[10px] lg:rounded-r-none',
                'px-[30px] py-[20px] shadow-[0px_2px_20px_0px_rgba(0,0,0,0.08)]',
                'backdrop-blur-30'
              )}
            >
              <div className="flex flex-col gap-[16px]">
                {/* Frame 2071857367 - Stats Row */}
                <div className="flex items-center gap-[16px]">
                  <div className="bg-white rounded-[10px] px-5 py-1 flex items-center h-14">
                    <span className="text-[26px] font-bold text-blue-800 leading-[1.25] font-lato">
                      10k+
                    </span>
                  </div>
                  <div className="text-white">
                    <div className="text-lg font-bold leading-[1.5] uppercase font-lato">
                      Giao dịch
                      <br />
                      Trực tuyến
                    </div>
                  </div>
                </div>

                {/* Appointment Text */}
                <div className="text-white text-base font-semibold leading-[1.5] uppercase font-urbanist">
                  +Hàng ngàn Giao dịch Thành công
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
